<template>
  <div>
    <v-container>
        <v-layout>
            <v-flex xs12>
              <div :id="adId">
              </div>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import postscribe from "postscribe";
var ready = require('document-ready')
//square ad
// <script async id="mNCC" type="text/javascript" language="javascript">var medianet_width = "180"; var medianet_height = "150"; var medianet_crid = "462272657"; var medianet_versionId = "3111299";<\/script>
// long ad
// <script async id="mNCC" type="text/javascript" language="javascript">var medianet_width = "468"; var medianet_height = "60"; var medianet_crid = "773677337"; var medianet_versionId = "3111299";<\/script>
export default {
  name: "Chitika",
  props:["adChoice"],
  data() {
    return {
      adId: Date.now(),
      adsArray:[`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":160,"height":600,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`,`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":300,"height":250,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`,
`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":320,"height":50,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`,
`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":300,"height":600,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`,`<script type="text/javascript">
	atOptions = {
		'key' : '0cf08f46b235b41ffa7dc4c5fb32d0d9',
		'format' : 'iframe',
		'height' : 60,
		'width' : 468,
		'params' : {}
	};
	document.write('<scr' + 'ipt type="text/javascript" src="http' + (location.protocol === 'https:' ? 's' : '') + '://www.bcloudhost.com/0cf08f46b235b41ffa7dc4c5fb32d0d9/invoke.js"></scr' + 'ipt>');
<\/script>`,`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":550,"height":250,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`,`<script type="text/javascript">
  ( function() {
    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
    var unit = {"calltype":"async[2]","publisher":"mandatory","width":728,"height":90,"sid":"Chitika Default"};
    var placement_id = window.CHITIKA.units.length;
    window.CHITIKA.units.push(unit);
    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
<\/script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async><\/script>`]
    };
  },

  mounted() {
    var vm = this;
    ready(function () {
      let addEl = new Promise((resolve, reject) => {
          postscribe(
            `#${vm.adId}`,
            `${vm.adsArray[vm.adChoice]}`,
            {
              done: function(x) {}
            }
          );

        resolve();
      });      
      addEl.then(function(result) {
        //console.log(result) do nothing
      });
    })

    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.container {
  max-width: 1250px;
}
</style>



// WEBPACK FOOTER //
// src/components/ads/Chitika.vue